import { Field, Form } from 'react-final-form';
import {
    Button,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';

const NewConfiguration = (props) => {
    const { isOpen, toggle, submit, configFor = 'UNKNOWN' } = props;

    const cancel = () => {
        toggle();
    };

    const finish = async (vals) => submit(vals).finally(() => toggle());

    return (
        <>
            <Modal
                className="text-light"
                isOpen={isOpen}
                centered={true}
                toggle={cancel}>
                <Form
                    onSubmit={finish}
                    render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        values,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <ModalHeader>
                                Create new Configuration for {configFor}
                            </ModalHeader>
                            <ModalBody>
                                <Row>
                                    <Col>
                                        <Field
                                            className="w-100 p-2 rounded border"
                                            component="input"
                                            label="Key"
                                            name="key"
                                            required
                                        />
                                    </Col>
                                    <Col>
                                        <Field
                                            className="w-100 p-2 rounded border"
                                            component="input"
                                            label="Value"
                                            name="value"
                                            required
                                        />
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="info"
                                    onClick={() =>
                                        pristine ? cancel() : form.reset()
                                    }>
                                    {pristine ? 'Cancel' : 'Clear'}
                                </Button>
                                <Button
                                    color="primary"
                                    disabled={pristine || submitting}
                                    type="submit">
                                    Create
                                </Button>
                            </ModalFooter>
                        </form>
                    )}
                />
            </Modal>
        </>
    );
};

export default NewConfiguration;
